import React from "react";
import { motion } from "framer-motion";
import { FaUserShield } from "react-icons/fa";
import { BsArrowRepeat } from "react-icons/bs";

const LoginAuthLoader = () => {
  return (
    <div style={styles.container}>
      <motion.div
        style={styles.card}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 60 }}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          style={styles.iconContainer}
        >
          <BsArrowRepeat size={40} color="#198754" />
        </motion.div>

        <div style={styles.header}>
          <FaUserShield size={28} color="#0d6efd" />
          <h3 style={{ marginLeft: 10 }}>Logging in securely</h3>
        </div>

        <p style={styles.text}>
          Verifying your credentials from browser session...
        </p>

        <div style={styles.progressBarWrapper}>
          <motion.div
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            style={styles.progressBar}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default LoginAuthLoader;

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: "100vh",
    background: "#f4f6f9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "white",
    padding: "2rem 3rem",
    borderRadius: "1rem",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    minWidth: 360,
    textAlign: "center",
  },
  iconContainer: {
    marginBottom: 20,
  },
  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  text: {
    color: "#555",
    fontSize: 16,
    marginBottom: 20,
  },
  progressBarWrapper: {
    width: "100%",
    height: 6,
    background: "#e0e0e0",
    borderRadius: 10,
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    background: "#198754",
    borderRadius: 10,
  },
};
